export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  // Vérifier si GTM est activé et si on est en production
  if (!config.public.gtmId || process.env.NODE_ENV !== "production") {
    console.info("GTM désactivé (environnement non compatible ou ID manquant)");
    return;
  }

  // Charger GTM après le chargement complet de la page
  window.addEventListener("load", () => {
    // Ajouter la balise <script>
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${config.public.gtmId}`;
    document.head.appendChild(script);

    // Ajouter la balise <noscript>
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${config.public.gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
  });
});
